import {
  SET_IS_CHAT_OPEN,
  SET_CHAT_VIEW,
  SET_SELECTED_CONVERSATION,
  SET_CONVERSATION_PAGINATION,
  SET_MESSAGES,
  UPDATE_MESSAGE_BY_ID,
  SET_LIVE_CONTEXT,
  CLEAR_CHAT_SESSION,
  SET_MESSAGE_SENT,
  SET_CALLOUT,
  SET_LAST_CHAT_CONVERSATION_ID,
} from "../Actions/types";

const initialState = {
  isChatOpen: false,
  chatView: "new",
  selectedConversation: null,
  conversationPagination: {
    page: 1,
    limit: 10,
    totalPages: 1,
    totalRecords: 0,
    hasMore: false,
  },
  messages: [],
  liveContext: {
    conversationId: "",
    threadId: "",
    lastMessageId: "",
  },
  messageSent: false,
  callout: null,
  lastChatConversationId: null,
};

export default function aiChatReducer(state = initialState, action) {
  switch (action.type) {
    case SET_IS_CHAT_OPEN:
      return { ...state, isChatOpen: action.payload };
    case SET_CHAT_VIEW:
      return { ...state, chatView: action.payload };
    case SET_SELECTED_CONVERSATION:
      return { ...state, selectedConversation: action.payload };
    case SET_CONVERSATION_PAGINATION:
      return {
        ...state,
        conversationPagination: {
          ...state.conversationPagination,
          ...action.payload,
        },
      };
    case SET_MESSAGES:
      return {
        ...state,
        messages:
          typeof action.payload === "function"
            ? action.payload(state.messages)
            : action.payload,
      };
    case UPDATE_MESSAGE_BY_ID:
      return {
        ...state,
        messages: state.messages.map(msg =>
          msg.id === action.payload.id
            ? { ...msg, ...action.payload.updater(msg) }
            : msg
        ),
      };
    case SET_LIVE_CONTEXT:
      return {
        ...state,
        liveContext: { ...state.liveContext, ...action.payload },
      };
    case SET_MESSAGE_SENT:
      return { ...state, messageSent: action.payload };

    // New Case Handler
    case SET_CALLOUT:
      return { ...state, callout: action.payload };

    case CLEAR_CHAT_SESSION:
      return {
        ...state,
        messages: [],
        messageSent: false,
        liveContext: { conversationId: "", threadId: "", lastMessageId: "" },
        callout: null,
      };
    case SET_LAST_CHAT_CONVERSATION_ID:
      return { ...state, lastChatConversationId: action.payload };
    default:
      return state;
  }
}
